var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.75 5.96a8.013 8.013 0 01-2.301.619 3.987 3.987 0 001.757-2.203 7.89 7.89 0 01-2.535.965 3.988 3.988 0 00-2.92-1.263 3.995 3.995 0 00-3.997 3.999c0 .309.038.618.098.916a11.358 11.358 0 01-8.24-4.184 3.968 3.968 0 00-.544 2.018c0 1.388.706 2.611 1.781 3.33a4.03 4.03 0 01-1.807-.508v.05a3.997 3.997 0 003.204 3.923c-.343.09-.697.135-1.052.136-.26 0-.506-.026-.755-.061a4.004 4.004 0 003.736 2.773 8.01 8.01 0 01-4.962 1.708c-.335 0-.644-.012-.965-.05a11.317 11.317 0 006.138 1.794c7.35 0 11.372-6.09 11.372-11.374 0-.174 0-.347-.012-.52A8.605 8.605 0 0021.75 5.96z"}));
}

Twitter.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Twitter;

Twitter.default = Twitter;
